import PhoneIcon from '@crm/shared/assets/icons/phone.svg?react';
import { SvgIcon } from '@crm/shared/ui';

export const DealCardPhone = ({ objectPhone }: { objectPhone: string | null }) => {
    if (!objectPhone) {
        return null;
    }

    return (
        <div className="flex items-center gap-1">
            <SvgIcon icon={PhoneIcon} size={12} />
            <span className="text-[13px] leading-4">{objectPhone}</span>
        </div>
    );
};
